import { useState, useEffect } from 'react';

export const ScreenSizes = {
  Small: 'Small',
  Medium: 'Medium',
  Large: 'Large',
};

const SMALL_MAX_SIZE = 768;
const MEDIUM_MAX_SIZE = 1366;

const checkIfSmallQuery = window.matchMedia(`(max-width: ${SMALL_MAX_SIZE}px)`);
const checkIfMediumQuery = window.matchMedia(`(min-width: ${SMALL_MAX_SIZE + 1}px) and (max-width: ${MEDIUM_MAX_SIZE}px)`);
const checkIfLargeQuery = window.matchMedia(`(min-width: ${MEDIUM_MAX_SIZE + 1}px)`);
const determineScreenSize = () => checkIfLargeQuery.matches
  ? ScreenSizes.Large
  : checkIfMediumQuery.matches
    ? ScreenSizes.Medium
    : ScreenSizes.Small
  ;

export const useScreenSizes = () => {
  const [screenSize, setScreenSize] = useState(determineScreenSize());

  useEffect(() => {
    const eventHandler = () => setScreenSize(determineScreenSize());
    const eventName = 'change';
    checkIfSmallQuery.addEventListener(eventName, eventHandler);
    checkIfMediumQuery.addEventListener(eventName, eventHandler);
    checkIfLargeQuery.addEventListener(eventName, eventHandler);
    return () => {
      checkIfSmallQuery.removeEventListener(eventName, eventHandler);
      checkIfMediumQuery.removeEventListener(eventName, eventHandler);
      checkIfLargeQuery.removeEventListener(eventName, eventHandler);
    };
  }, [setScreenSize]);

  return screenSize;
};